/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { connect } from 'react-redux'
import { FsCore } from '@t/fs-core'
import { brand } from '@r/app-selectors'

interface IconProps {
  glyph: any
  color: string
  size: 8 | 10 | 13 | 24 | 26 | 32 | 36 | 45 | 48
  desktopSize?: 32 | 40 | 42 | 48 | 65
  fill?: string
  brand: 'money' | 'uswitch'
}

const iconVersion = 13

const Icon: React.FC<IconProps> = ({ glyph, size, desktopSize, color, fill, brand }) => {
  const basePath = process.env.IN_STORYBOOK ? `/icons/${brand}` : `/fs-core-assets/icons/${brand}`
  const url = `${basePath}/${glyph}.svg?v=${iconVersion}#${glyph}`
  return (
    <svg
      className={
        desktopSize
          ? `DynamicIcon__${size} DynamicIcon__desktop__${desktopSize}`
          : `DynamicIcon__${size}`
      }
      stroke={color}
      fill={fill}
      color={color}
    >
      <use href={url} />
    </svg>
  )
}

export default connect((state: FsCore.State, props: any) => {
  return {
    brand: brand(state),
    ...props,
  }
})(Icon)
